import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

// This is a half-copy of the market.settings controller with some stuff removed
// Make sure to update this file if the market settings controller is updated
export default class DestinationSettingsController extends Controller {
  @service declare access: Services['access'];
  @service declare settingsUsers: Services['settings-users'];
  /* Disable unused service linting rule for theme service as it is used in the template */
  /* eslint-disable-next-line ember/no-unused-services */
  @service declare theme: Services['theme'];

  @tracked isSettingsDrawerOpen = true;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasGeneralGroup() {
    return (
      this.hasUserAccessSettings ||
      this.access.hasFeature('settings.hotel_access.edit') ||
      this.access.hasFeature('reports.view.settings')
    );
  }

  get hasHotelAccessSettings(): boolean {
    return (
      !this.hasUserAccessSettings &&
      this.access.hasFeature('settings.hotel_access.edit')
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasPersonalSettingsGroup() {
    return (
      this.access.hasPersonalSettingsTab ||
      this.access.canEditPersonalSettingsPassword
    );
  }

  get hasUserAccessSettings(): boolean {
    return this.settingsUsers.canOpenMultiHotelUsersTab;
  }

  @action toggleNavbar(): void {
    this.isSettingsDrawerOpen = !this.isSettingsDrawerOpen;
  }
}
